import _get from 'lodash/get';
import _trim from 'lodash/trim';
import _isEmpty from 'lodash/isEmpty';
import { tget } from '@tekion/tekion-base/utils/general';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
var getVehicleOptionLabel = function getVehicleOptionLabel() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  if (_isEmpty(option)) {
    return '';
  }
  var stockId = _get(option, 'data.stockID');
  return stockId;
};
export var getDescriptiveVehicleOptionLabel = function getDescriptiveVehicleOptionLabel() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  if (_isEmpty(option)) {
    return '';
  }
  var stockId = _get(option, 'data.stockID');
  var year = tget(option, 'data.year', '');
  var make = tget(option, 'data.make', '');
  var model = tget(option, 'data.model', '');
  var vin = tget(option, 'data.vin', '');
  var name = _trim("".concat(year, " ").concat(make, " ").concat(model));
  return "".concat(stockId, " - ").concat(name, " ").concat(vin);
};
export var getVehicleOptionValue = function getVehicleOptionValue() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  return _get(option, 'data.id');
};
var VEHICLE_OPTION_CONFIG = {
  getOptionLabel: getVehicleOptionLabel,
  getOptionValue: getVehicleOptionValue
};
export var DESCRIPTIVE_VEHICLE_OPTION_CONFIG = {
  getOptionLabel: getDescriptiveVehicleOptionLabel,
  getOptionValue: getVehicleOptionValue
};
export default VEHICLE_OPTION_CONFIG;